import { ExternalLink } from 'lucide-react'
import { DefaultTooltip } from 'twyne-new.ui'

import { getInfo } from '@Components/Grid/components/Table/formatters'

import { buildFileUrl } from '../../utils'

export default function FileLink({ info }) {
  const { row } = getInfo(info)

  return <DefaultTooltip content='View file'>
    <a href={buildFileUrl(row.path)} target='_blank' rel='noreferrer' className='action'>
      <ExternalLink size={16} />
    </a>
  </DefaultTooltip>
}
